import styled from '@emotion/styled'
import { Text } from 'theme-ui'

import { WithTheme } from '../../../setup'
import { IconTick } from '../../../assets/svg'
import media from '../../../common/MediaQueries'
import { listReset } from '../../../common/Mixins'

export const TradeBenefitsStyled = styled.div`
  position: relative;
  margin-top: 2.75rem;
`

export const TradeBenefitsMediaStyled = styled.div``

export const TradeBenefitsListBoxStyled = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 5.75rem;
  @media ${media.desktop} {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin-top: 4rem;
  }
`

export const TradeBenefitsIconStyled = styled(IconTick)`
  margin: 0.5rem 1.25rem 0 0;
  min-width: 1rem;
`

export const TradeBenefitsLabelStyled = styled(Text)<WithTheme>`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-family: 'Montserrat';
`

export const TradeBenefitsListStyled = styled.ul`
  ${listReset}
  @media ${media.desktop} {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 85.375rem;
    margin: 0 auto;
    align-items: center;
  }
`

export const TradeBenefitsListItemStyled = styled.li`
  display: flex;
  &:not(:first-child) {
    margin-top: 1.5rem;
  }
  @media ${media.desktop} {
    width: 50%;
    padding: 1.75rem 0;
    &:not(:first-child) {
      margin-top: 0;
    }
    ${TradeBenefitsLabelStyled} {
      width: calc(100% - (53rem / 2));
      max-width: 15.625rem;
    }
    &:nth-child(even) {
      justify-content: flex-end;
      ${TradeBenefitsLabelStyled} {
        max-width: 12.75rem;
      }
    }
  }
`
